import { IncomingMessage } from "http";

export const getShop = async (req: IncomingMessage) => {
  const headers = req.headers as Record<string, string>;
  const headersList = new Headers(Object.entries(headers));
  const shop = headersList.get("asos-shop");

  if (!shop) {
    throw new Error("No shop header found");
  }

  return shop;
};
